<template>
  <div class="d-flex flex-column justify-content-between border-left h-100">
    <div
      v-for="(item, index) in options"
      :key="`tab-item-${index}`"
      class="compact cursor-pointer"
      :class="{
        'compact--active': item.active,
        compact__first: item.active && item.id === 0,
        compact__last: item.active && item.id === 3,
      }"
      @click="onSelect(index, item.tabKey)"
    >
      <em
        class="d-flex justify-content-center py-2"
        :class="iconClass(item.icon)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompactNavTabs',
  props: {
    value: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      options: [
        {
          id: 0,
          icon: 'info',
          tabKey: 'tabSection',
        },
        {
          id: 1,
          icon: 'calendar-alt',
          tabKey: 'manualAdjustmentSection',
        },
        {
          id: 2,
          icon: 'dollar-sign',
          tabKey: 'paymentRelationshipSection',
        },
        {
          id: 3,
          icon: 'history',
          tabKey: '',
        },
      ],
    };
  },
  computed: {
    iconClass() {
      return (icon) => `fas fa-${icon}`;
    },
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal != oldVal) {
        this.setActiveTab(newVal);
      }
    },
  },
  methods: {
    setActiveTab(itemIndex) {
      this.options = this.options.map((item, index) => {
        if (itemIndex == null) {
          item.active = null;
        } else {
          item.active = itemIndex === index;
        }
        return item;
      });
    },
    onSelect(itemIndex) {
      this.setActiveTab(itemIndex);
      this.$emit('on-select-tab-index', itemIndex);
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.compact {
  em {
    color: map-get($colors, 'secondary-35');
    font-size: 0.875rem;
  }
  &--active {
    background: map-get($colors, 'green');
    em {
      color: map-get($colors, 'white');
    }
  }
  &__first {
    border-top-right-radius: 5px;
  }
  &__last {
    border-bottom-right-radius: 5px;
  }
}
</style>
